import React, { useEffect } from "react";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import QuestsListElement from "../../../assets/components/questListElement";
import Classes from "./styles/style.module.css";
import { useDispatch, useSelector } from "react-redux";
import UsersRequests from "../../../assets/services/user";
import { useParams } from "react-router";

const steps = [
  [
    { title: "ماموریت یک", pageId: 1294 },
    { title: "ماموریت دو", pageId: 1336 },
    { title: "ماموریت سه", pageId: 1364 },
  ],
  [
    { title: "ماموریت یک", pageId: 1424 },
    { title: "ماموریت دو", pageId: 1435 },
  ],
  [
    { title: "ماموریت یک", pageId: 1479 },
    { title: "ماموریت دو", pageId: 1508 },
  ],
  [
    { title: "ماموریت یک", pageId: 1562 },
    { title: "ماموریت دو", pageId: 1571 },
  ],
  [
    { title: "ماموریت یک", pageId: 1598 },
    { title: "ماموریت دو", pageId: 1600 },
  ],
  [
    { title: "ماموریت یک", pageId: 1611 },
    { title: "ماموریت دو", pageId: 1613 },
  ],
  [{ title: "ماموریت یک", pageId: 1618 }],
  [
    { title: "ماموریت یک", pageId: 1625 },
    { title: "ماموریت دو", pageId: 1628 },
  ],
  [
    { title: "ماموریت یک", pageId: 1639 },
    { title: "ماموریت دو", pageId: 1641 },
  ],
  [
    { title: "ماموریت یک", pageId: 1648 },
    { title: "ماموریت دو", pageId: 1650 },
  ],
  [
    { title: "ماموریت یک", pageId: 1655 },
    { title: "ماموریت دو", pageId: 1659 },
  ],
];
const ChallengeList = () => {
  const { currentUser } = useSelector(({ user }) => user);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(UsersRequests.getme());
  }, []);

  const { messionNumber } = useParams();

  const navigatorHandler = async (pageId) => {
    if (currentUser?.nationalCode) {
      window.location.href = `https://app.rahebehesht.com/?page_id=${pageId}&fullName=${currentUser.fullName}&codeMeli=${currentUser.nationalCode}&codePersoneli=${currentUser.personnelCode}&phone=${currentUser.phone}`;
    }
  };

  return (
    <AnimatedPageContainer>
      <div className={Classes.container}>
        {messionNumber === "gift" ? (
          <>
            <QuestsListElement
              score={null}
              title={"ماموریت 22 بهمن"}
              subTitle={"جهت شرکت کلیک کنید"}
              handleClick={() => navigatorHandler(1587)}
            />
            <QuestsListElement
              score={null}
              title={"ماموریت نیمه شعبان"}
              subTitle={"جهت شرکت کلیک کنید"}
              handleClick={() => navigatorHandler(1635)}
            />
          </>
        ) : (
          steps[messionNumber - 1].map((item) => (
            <QuestsListElement
              key={item.pageId}
              score={null}
              title={item.title}
              subTitle={"جهت شرکت کلیک کنید"}
              handleClick={() => navigatorHandler(item.pageId)}
            />
          ))
        )}
      </div>
    </AnimatedPageContainer>
  );
};

export default ChallengeList;
